function expDampFactor(deltaSeconds, factor) {
  if (factor <= 0) {
    return 1;
  }
  if (deltaSeconds <= 0) {
    return 0;
  }
  return 1 - Math.pow(2, -deltaSeconds / factor);
}
function dampScalar(current, goal, t) {
  return current + (goal - current) * t;
}
function lerpAngleShortest(current, goal, t) {
  const twoPi = Math.PI * 2;
  let delta = (goal - current) % twoPi;
  if (delta > Math.PI) {
    delta -= twoPi;
  } else if (delta < -Math.PI) {
    delta += twoPi;
  }
  return current + delta * t;
}

export { dampScalar, expDampFactor, lerpAngleShortest };
//# sourceMappingURL=damp.js.map
